import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import {
  People,
  Check,
  Cancel,
} from '@mui/icons-material';
import { THEME_COLORS } from '../../constants';

/**
 * Componente de estadísticas de contactos
 */
const ContactStats = ({ stats }) => {
  const statsData = [
    {
      title: 'Total Contactos',
      value: stats.total || 0,
      icon: <People sx={{ fontSize: '2rem', color: '#1a1a1a' }} />,
      color: '#1a1a1a',
    },
    {
      title: 'Suscripciones Activas',
      value: stats.active || 0,
      icon: <Check sx={{ fontSize: '2rem', color: '#374151' }} />,
      color: '#374151',
    },
    {
      title: 'Suscripciones Vencidas',
      value: stats.expired || 0,
      icon: <Cancel sx={{ fontSize: '2rem', color: '#9ca3af' }} />,
      color: '#9ca3af',
    },
    {
      title: 'Sin Suscripción',
      value: stats.never_subscribed || 0,
      icon: <Cancel sx={{ fontSize: '2rem', color: '#6b7280' }} />,
      color: '#6b7280',
    },
  ];

  return (
    <Grid container spacing={3} sx={{ marginBottom: 4 }}>
      {statsData.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              height: '100%',
              border: `1px solid ${THEME_COLORS.BORDER}`,
              borderRadius: '12px',
              backgroundColor: THEME_COLORS.WHITE,
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
                borderColor: stat.color,
              },
            }}
          >
            <CardContent sx={{ padding: 3 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      color: stat.color,
                      fontWeight: 700,
                      fontSize: { xs: '1.75rem', sm: '2rem' },
                      marginBottom: 0.5,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: THEME_COLORS.TEXT_SECONDARY,
                      fontWeight: 500,
                      fontSize: '0.875rem',
                    }}
                  >
                    {stat.title}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 60,
                    height: 60,
                    borderRadius: '12px',
                    backgroundColor: `${stat.color}15`,
                  }}
                >
                  {stat.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ContactStats; 